import { OrderAdjustmentLiteModel } from 'api-hooks/order-adjustment';
import { NavigationRoutes } from 'common/constants';
import { PaginationMeta } from 'common/repositories/common.model';
import PaginationComponent from 'components/elements/pagination-component';
import TableComponent, {
  IColumn,
} from 'components/elements/table-component/table-component';
import { TableContainer } from 'components/styles';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import * as React from 'react';
interface Props {
  orderAdjustments: any[];
  loading?: boolean;
  page: number;
  onPageChange: (page: number) => void;
  meta?: PaginationMeta;
  sortColumns: IColumn<OrderAdjustmentLiteModel>[];
}

export default function OrderAdjustmentTable(props: Props) {
  const { orderAdjustments, loading, page, onPageChange, meta, sortColumns } =
    props;

  const permission = useGetCrudPermission('order-adjustments');

  const columns = React.useMemo<IColumn<OrderAdjustmentLiteModel>[]>(
    () => [
      {
        header: '#',
        accessorKey: 'index',
        stickyLeft: true,
        minSize: 40,
        maxSize: 40,
        cell: ({ row }) => {
          return (
            <>
              {row.index +
                1 +
                ((meta?.currentPage || 1) - 1) * (meta?.perPage || 1)}
            </>
          );
        },
      },
      ...sortColumns,
    ],
    [meta?.currentPage, meta?.perPage, sortColumns],
  );

  return (
    <>
      <TableContainer>
        <TableComponent
          columns={columns}
          isLoading={loading}
          data={orderAdjustments || []}
          rowLink={(row) => {
            if (!permission.view) return undefined;
            return {
              pathname: NavigationRoutes.OrderAdjustmentView,
              query: {
                id: row.original.id,
              },
            };
          }}
        />
      </TableContainer>
      <PaginationComponent
        page={page}
        onPageChange={onPageChange}
        meta={meta}
      />
    </>
  );
}
